export default "__VITE_ASSET__fd717911__"